import {
    MessageFieldsFragment,
    namedOperations,
    useWritebackChatMutation,
} from '~graphql/generated/graphql'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'

export function useWritebackMessages() {
    const toasts = useToastFeedback(
        'Successfully saved message to PIMS!',
        'Error saving message to PIMS',
    )

    const [writebackChatMutation, { loading }] = useWritebackChatMutation()

    const writebackMessage = async (
        chatId: string,
        messages: Pick<MessageFieldsFragment, 'id'>[],
        // patientId?: string,
    ) => {
        const messageIds = messages.map(m => m.id)

        await writebackChatMutation({
            variables: {
                chatId,
                messageIds,
                isManualWriteback: true,
            },
            refetchQueries: [namedOperations.Query.getMessagesByChatId],
            onCompleted: data => {
                // An empty result means every selected message was skipped
                // (failed sends and previews are never written to the PIMS),
                // so don't claim it was saved.
                if (!data?.writebackChat?.length) {
                    toasts.onError(
                        'None of the selected messages could be saved to the PIMS — they may have failed to send.',
                    )
                    return
                }
                toasts.onCompleted()
            },
            onError: error => toasts.onError(error.message),
        })
    }

    return [writebackMessage, { loading }] as const
}
